export default __webpack_public_path__ + "static/media/chatIcon.b4c14758.svg";